export default "__VITE_ASSET__CGTm3qF6__"